(() => {
  const init = () => document.querySelectorAll('[data-pk-home-benefits-controls]').forEach(controls => {
    if (controls.dataset.ready) return;
    const track = controls.closest('.pk-benefits-review')?.querySelector('.benefit-grid');
    if (!track) return;
    controls.dataset.ready = 'true';
    const prev = controls.querySelector('[data-benefits-prev]');
    const next = controls.querySelector('[data-benefits-next]');
    const update = () => {
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    const move = direction => {
      const item = track.querySelector('.benefit-item');
      if (!item) return;
      const distance = item.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
      track.scrollBy({left: direction * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    };
    prev.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', update, {passive: true});
    if (typeof ResizeObserver !== 'undefined') new ResizeObserver(update).observe(track);
    else window.addEventListener('resize', update);
    controls.hidden = false;
    requestAnimationFrame(update);
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();
